module.exports = __webpack_public_path__ + "img/search.d416e54b.png";